module.exports = __webpack_public_path__ + "image/dealer_banner.jpg";